import { withStyles } from "@material-ui/core";
import React from "react";
import { v4 as uuidv4 } from "uuid";
import { getDataWithQueryString } from "../../../../../../../api/componentAPIs";
import constants from "../../../DriverPopUp/EditStopDialog/constants";
import FormSectionHeader from "../common/FormSectionHeader";
import SearchBar from "../components/SearchBar";
import { SelectWithLabel } from "../components/Select";
import {
  StyledTextField as TextField, TextFieldWithLabel
} from "../components/TextField";
import {
  FORM_VALIDATION_MSG,
  MAX_LENGTH_CONSTRAINTS,
  MAX_VALUE_CONSTRAINTS,
  PICKUP_MANAGEMENT_MODES,
  SEARCH_FILTER_OPTIONS
} from "../constants";
import { isVoidPickupMode, isMergePickupMode, fetchLocationMappingData } from "../utils";
import styles from "./styles";
import {
  getFieldError,
  getSearchParamsByType,
  getSearchProps,
  getSelectedShipperData,
  isValidSearchString,
} from "./utils";
import { withSnackbar } from "notistack";
import { compose } from "recompose";
import { AutoCompleteInputWithLabel } from "../components/Autocomplete";
import LocationDropdownItem from "../ShipmentInfo/Grid/components/LocationDropdownItem"
import axios from 'axios';
import ShipperMenuItem from "../components/ShipperMenuItem";
class ShipperInfoForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      shipperList: [],
      shipperData: [],
      searchBy: SEARCH_FILTER_OPTIONS[0].value,
      locationMappingData: [],
      searchInputValue: "",
      zipInputValue: this.props.shipperInfo.shipperZip || "",
      showSearchedOptions: false,
      isLoading: false,
      isZipDataloading: false,
      zipError : false,
    };
    this.cancelShipperRequest = null;
  }

  componentDidMount() {
    const { shipperInfo, mode } = this.props;
    if (!isVoidPickupMode(mode) && shipperInfo.shipperZip) {
      this.getLocationMappingByZip(shipperInfo.shipperZip);
    }
  }

  componentDidUpdate(prevProps) {
    const { shipperInfo, mode } = this.props;
    if (
      isMergePickupMode(mode) &&
      prevProps.shipperInfo.rmaxShipperCode !== shipperInfo.rmaxShipperCode
    ) {
      this.updateZip(shipperInfo.shipperZip);
      this.getLocationMappingByZip(shipperInfo.shipperZip);
    }
  }

  handleChange = (name) => (value) => {
    if (name === "shipperContactPhone") {
      value = value.replace(/\D+/g, "");
    }
    this.updateShipperInfo(name, value);
  };

  getShipperList = (shippers, inputValue) => {
    if (shippers.length) {
      return shippers.map((shipper) => ({
        ...shipper,
        isNewValue: false,
        label: <ShipperMenuItem data={shipper}/>,
        id: shipper.rmaxShipperCode
      }));
    }
    return this.state.searchBy === SEARCH_FILTER_OPTIONS[0].value &&
      !isMergePickupMode(this.props.mode)
      ? [
          {
            shipperName: inputValue,
            isNewValue: true,
            label: `Add "${inputValue}"`,
            id: uuidv4(),
          },
        ]
      : [];
  };

  searchShipper = (searchInputValue, validate = true) => {
    if (!this.props.searchFieldError && (!validate || isValidSearchString(this.state.searchBy, searchInputValue))) {
      this.cancelShipperRequest?.('GetShippersAtTerminal cancelled');    // Cancel ongoing request if any
      const CancelToken = axios.CancelToken;
      this.setState({
        isLoading: true,
        showSearchedOptions: true,
      });
      getDataWithQueryString(
        "GetShippersAtTerminal",
        getSearchParamsByType(
          this.props.userProfile.terminal.code,
          this.state.searchBy,
          this.props.selectedTerminal,
          searchInputValue
        ),
        {
          cancelToken: new CancelToken((c) => {
            this.cancelShipperRequest = c;
          }),
        }
      ).then((response) => {
        if (response.status === 200) {
          this.setState({
            shipperList: this.getShipperList(response.data, searchInputValue),
            shipperData: response.data,
            isLoading: false,
          });
        } else {
          if (axios.isCancel(response)) {
            return null;
          }
          this.props.enqueueSnackbar("Unable to fetch shipper data.", {
            variant: "error",
          });
          this.setState({
            showSearchedOptions: false,
            shipperList: [],
            isLoading: false,
          });
        }
      });
    } else {
      this.setState({
        showSearchedOptions: false,
      });
    }
  };

  handleSearch = () => {
    const { searchInputValue } = this.state;
    searchInputValue && this.searchShipper(searchInputValue, false);
  }

  handleSelect = (value) => {
    const selectedShipper = JSON.parse(value);
    if (!selectedShipper.isNewValue) {
      this.fetchSelectedShipperDetails(selectedShipper);
    } else {
      this.updateShipperInfo("shipperName", selectedShipper.shipperName);
    }
    this.setState({ showSearchedOptions: false });
    this.searchBarRef.focus()
  };

  updateShipperInfo = (name, value) => {
    const shipperInfo = {
      ...this.props.shipperInfo,
      [name]: value
    };
    const shipperErrorInfo = {
      ...this.props.shipperErrorInfo,
      [name]: getFieldError({ field: name, value }),
    };
    this.props.updateFormData("shipperInfo", shipperInfo, shipperErrorInfo);
  };

  fetchSelectedShipperDetails = (shipperDetails) => {
    if (shipperDetails) {
      this.autoPopulateShipperInfo(
        shipperDetails,
        shipperDetails.shipperName
      );
    }
  };

  autoPopulateShipperInfo = (shipperData, searchInputValue) => {
    if(isMergePickupMode(this.props.mode)){
      return this.updateMergePickupDataOnShipperSelection(
        shipperData,
        searchInputValue
      );
    }
    const zipInputValue = shipperData ? shipperData.shipperZip : "";
    this.setState(
      {
        shipperList: [],
        searchInputValue,
        locationMappingData: [],
      },
      () => this.updateZip(zipInputValue)
    );
    shipperData && this.getLocationMappingByZip(shipperData.shipperZip , false);
    this.updateShipperDataOnSearch(shipperData);
  };

  updateMergePickupDataOnShipperSelection = (shipperData, searchInputValue) => {
    this.setState(
      {
        shipperList: [],
        searchInputValue,
      },
    );
    this.updateShipperDataOnSearch(shipperData);
  }

  updateShipperDataOnSearch = (shipperData) => {
    const searchedShipperData = getSelectedShipperData(
      shipperData,
      this.props.selectedTerminalOffset
    );
    this.props.updateSelectedShipperDataOnSearch({
      ...searchedShipperData,
      isMiscellaneousShipper: shipperData?.isMiscellaneousShipper,
      isShipperSearched : Boolean(shipperData)
    });
  };

  handleSearchChange = (value) => {
    this.setState(
      {
        searchInputValue: value,
        shipperList: [],
      },
      () => {
        if (!value) {
          this.autoPopulateShipperInfo(null, value);
        }
      }
    );
    this.searchShipper(value);
  };

  getLocationMappingByZip = (zip ,selectZip = true) => {
    const {shipperInfo}=this.props;
    if (zip && zip.length > 4) {
      this.setState({
        isZipDataloading: true,
        locationMappingData: [],
      });
      fetchLocationMappingData({
        terminalCode: this.props.userProfile.terminal.code,
        zipCode: zip,
      })
        .then((response) => {
          if (response && response.status === 200) {
            const formattedLocationData = this.getFormattedLocations(
              response.data
            );
            this.setState({
              locationMappingData: formattedLocationData,
              isZipDataloading: false,
            });
            if (
              !shipperInfo.shipperCity &&
              !shipperInfo.shipperState &&
              selectZip
            ) {
              formattedLocationData.length &&
                this.handleZipSelection(
                  JSON.stringify(formattedLocationData[0])
                );
            }
          } else {
            this.setState({
              locationMappingData: [],
              isZipDataloading: false,
              zipError: true,
            });
          }
        })
        .catch((_error) => {
          this.setState({
            locationMappingData: [],
            isZipDataloading: false,
            zipError: true,
          });
        });
    }
  };

  handleZip = (value) => {
    this.setState({ zipInputValue: value, zipError : false },() => {
      this.updateLocationData(value);
    });
    this.getLocationMappingByZip(value);
  };

  updateLocationData = (value) => {
    const shipperInfo = {
      ...this.props.shipperInfo,
      shipperZip: value,
      shipperCity: "",
      shipperState: "",
    };
    const shipperErrorInfo = {
      ...this.props.shipperErrorInfo,
      shipperZip: getFieldError({
        field: "shipperZip",
        value,
      }),
    };
    this.setState({
      locationMappingData: [],
    });
    this.props.updateFormData("shipperInfo", shipperInfo, shipperErrorInfo);
  };

  handleZipSelection = (value) => {
    const selectedLocation = JSON.parse(value);
    const shipperInfo = {
      ...this.props.shipperInfo,
      shipperZip: selectedLocation.zip,
      shipperCity: selectedLocation.city,
      shipperState: selectedLocation.state,
    };
    const shipperErrorInfo = {
      ...this.props.shipperErrorInfo,
      shipperZip: getFieldError({
        field: "shipperZip",
        value: selectedLocation.zip,
      }),
    };
    this.props.updateFormData("shipperInfo", shipperInfo, shipperErrorInfo);
  };

  handleSearchType = (searchBy) => () => {
    this.setState({ searchBy });
    this.handleSearchChange("");
    this.searchBarRef.focus();
  };

  getFormattedLocations = (locations) => {
    if (locations.length) {
      return locations.map((location) => ({
        ...location,
        id: location.zip + location.city + location.state,
        label: location.zip,
      }));
    }
    return []
  };

  updateZip = (zipInputValue) => {
    this.setState({
      zipInputValue,
    });
  }

  render() {
    const {
      classes,
      terminals,
      handleTerminalChange,
      selectedTerminal,
      shipperInfo,
      shipperErrorInfo,
      mode,
      updateFormData,
      specialInstructions,
      selectedTerminalError,
      searchFieldError,
      getTerminalRef,
      isReadOnly,
    } = this.props;
    const { searchInputValue, searchBy, zipInputValue, showSearchedOptions } = this.state;
    const { placeholder, inputProps } = getSearchProps(searchBy);
    return (
      <div className={classes.formContainer} id="shipperDetails">
        <SelectWithLabel
          label="Terminal :"
          data={terminals}
          textFieldProps={{
            id: "terminal",
            variant: "outlined",
            helperText: selectedTerminalError,
          }}
          inputClass={classes.terminal}
          onChange={handleTerminalChange}
          error={selectedTerminalError}
          value={selectedTerminal}
          labelClass={classes.labelStyle}
          isReadOnly={isReadOnly || isMergePickupMode(mode)}
          autoFocus
          getInputRef={getTerminalRef}
        />
        {(mode === PICKUP_MANAGEMENT_MODES.CREATE_PICKUP ||
          isMergePickupMode(mode)) && (
          <>
            <FormSectionHeader label="Search by shipper’s" />
            <SearchBar
              filterOptions={SEARCH_FILTER_OPTIONS}
              open={showSearchedOptions}
              handleFilterChange={this.handleSearchType}
              selectedFilter={searchBy}
              placeholder={placeholder}
              searchedValue={searchInputValue}
              handleChange={this.handleSearchChange}
              noOptionsMsg="No Shipper Found"
              handleSelect={this.handleSelect}
              forwardRef={(el) => (this.searchBarRef = el)}
              options={this.state.shipperList}
              inputProps={inputProps}
              showLoader={this.state.isLoading}
              loadingMessage="Loading..."
              error={searchFieldError}
              handleSearch={this.handleSearch}
              isReadOnly = {isReadOnly}
            />
          </>
        )}
        <FormSectionHeader label="Shipper Details" />
        <div className={classes.shipperInfoFormWrapper}>
          <TextFieldWithLabel
            label="Account # :"
            id="accountNumber"
            value={shipperInfo.shipperAccountNumber}
            className={classes.account}
            disabled
            isReadOnly={isReadOnly}
          />
          <TextFieldWithLabel
            label="Contact Name :"
            id="shipperContactName"
            handleChange={this.handleChange("shipperContactName")}
            error={shipperErrorInfo.shipperContactName}
            value={shipperInfo.shipperContactName}
            className={classes.defaultInput}
            inputProps={{
              maxLength:
                MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM.SHIPPER_CONTACT_NAME,
            }}
            isReadOnly={isReadOnly}
          />
          <TextFieldWithLabel
            label="Contact # :"
            id="shipperContactPhone"
            handleChange={this.handleChange("shipperContactPhone")}
            mask={constants.PHONE_NUMBER_MASK}
            error={shipperErrorInfo.shipperContactPhone}
            value={shipperInfo.shipperContactPhone}
            className={classes.contact}
            isReadOnly={isReadOnly}
          />
          <TextFieldWithLabel
            label="Email :"
            id="shipperEmail"
            handleChange={this.handleChange("shipperEmail")}
            error={shipperErrorInfo.shipperEmail}
            value={shipperInfo.shipperEmail}
            className={classes.defaultInput}
            isReadOnly={isReadOnly}
          />
          <TextFieldWithLabel
            label="Shipper Name :"
            id="shipperName"
            handleChange={this.handleChange("shipperName")}
            error={shipperErrorInfo.shipperName}
            value={shipperInfo.shipperName}
            className={classes.defaultInput}
            inputProps={{
              maxLength:
                MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM.SHIPPER_CONTACT_NAME,
            }}
            isReadOnly={isReadOnly}
          />
          <AutoCompleteInputWithLabel
            ref={(el) => (this.input = el)}
            items={this.state.locationMappingData}
            placeholder="Enter Zip"
            noOptionsMsg={
              this.state.zipError ? (
                <span className={classes.error}>
                  {FORM_VALIDATION_MSG.ZIP_CODE.INVALID_VALUE}
                </span>
              ) : (
                "No Zip Found"
              )
            }
            id="shipperZip"
            value={zipInputValue}
            handleChange={this.handleZip}
            handleSelect={this.handleZipSelection}
            OptionsRenderer={LocationDropdownItem}
            error={shipperErrorInfo.shipperZip}
            inputProps={{
              maxLength: MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM.SHIPPER_ZIP,
              max: MAX_VALUE_CONSTRAINTS.CREATE_PICKUP_FORM.SHIPPER_ZIP,
            }}
            showLoader={this.state.isZipDataloading}
            loadingMessage="Loading..."
            label="Zip :"
            isReadOnly={isReadOnly}
          />
          <TextFieldWithLabel
            label="City :"
            id="city"
            value={shipperInfo.shipperCity}
            inputClass={classes.defaultInput}
            isReadOnly
          />
          <TextFieldWithLabel
            label="State :"
            id="state"
            value={shipperInfo.shipperState}
            className={classes.account}
            isReadOnly
          />
          <TextFieldWithLabel
            label="Address 1 :"
            id="shipperAddress1"
            handleChange={this.handleChange("shipperAddress1")}
            error={shipperErrorInfo.shipperAddress1}
            value={shipperInfo.shipperAddress1}
            className={classes.defaultInput}
            inputProps={{
              maxLength:
                MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM.SHIPPER_ADDRESS1,
            }}
            isReadOnly={isReadOnly}
          />
          <TextFieldWithLabel
            label="Address 2 :"
            id="address2"
            handleChange={this.handleChange("shipperAddress2")}
            value={shipperInfo.shipperAddress2}
            className={classes.defaultInput}
            inputProps={{
              maxLength:
                MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM.SHIPPER_ADDRESS1,
            }}
            isReadOnly={isReadOnly}
          />
        </div>
        <FormSectionHeader label="Special Instructions :" />
        <TextField
          id="specialInstructions"
          handleChange={(value) =>
            updateFormData("specialInstructions", value, shipperErrorInfo)
          }
          value={specialInstructions}
          className={classes.defaultInput}
          multiline
          rows={3}
          disabled={isReadOnly}
        />
      </div>
    );
  }
}

export default compose(withSnackbar, withStyles(styles))(ShipperInfoForm);
